import { DataGridPro, GridColDef, GridRenderEditCellParams, GridRowModel, GridRowsProp, GridValidRowModel } from '@mui/x-data-grid-pro';
import * as React from 'react';

//@ts-ignore
import { Box } from '@mui/material';
import { useGridApiContext } from '@mui/x-data-grid-pro';
import { ChangeEvent, useCallback, useRef } from 'react';
import { atributos_options } from '@/utils/selectorOptions';

export default function CustomFilterParams({ onChange }: { onChange: (key: string, value: string | number) => void }) {


    const processRowUpdate = useCallback(
        async (newRow: GridRowModel) => {
            const { campo, valor } = newRow
            onChange(campo, valor)
        },
        [onChange],
    );
    const handleProcessRowUpdateError = React.useCallback((error: Error) => {

    }, []);


    return (
        <div style={{ height: 300, width: '100%', maxWidth: '50rem' }}>
            <DataGridPro
                editMode="row"
                rows={rows}
                columns={columns}
                hideFooter
                processRowUpdate={processRowUpdate}
                onProcessRowUpdateError={handleProcessRowUpdateError}


            />
        </div>
    );
}

const columns: GridColDef[] = [
    { field: 'campo', headerName: 'Campo', width: 180, editable: false },
    {
        field: 'valor',
        headerName: 'Valor',
        type: 'custom',
        width: 345,
        editable: true,
        align: 'left',
        headerAlign: 'left',
        renderEditCell: (params: GridRenderEditCellParams) => (
            <CustomEditComponent {...params} />
        ),
    }
];

function CustomEditComponent(props: GridRenderEditCellParams) {
    const { id, value, field, hasFocus } = props;
    const apiRef = useGridApiContext();
    const ref = useRef<HTMLInputElement>(null);

    React.useEffect(() => {
        if (hasFocus) {
            ref.current?.focus();
        }
    }, [hasFocus]);

    const handleValueChange = (event: ChangeEvent<HTMLInputElement>) => {
        const newValue = event.target.value
        apiRef.current.setEditCellValue({ id, field, value: newValue })
    };

    return hasFocus ? <Box
        onKeyDown={(e) => {
            if (e.key === 'Enter') {
                ref.current?.blur()
            }
        }}
        component="input"
        sx={{
            width: '100%',
            height: '100%',
            border: 0,
            '&:focus': {
                border: 0,
            },
            '&:focus-visible': {
                outline: 'none',
            }
        }}
        ref={ref}
        type="text"
        value={value}
        onChange={handleValueChange}
    /> : <div>{value}</div>;
}



const rows: GridRowsProp = [

    ...atributos_options.map((atributo, i) => {
        return {
            id: i,
            campo: atributo.label,
            valor: ''

        } as GridValidRowModel
    })

];